import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=604c2070&"
import script from "./manual.vue?vue&type=script&lang=js&"
export * from "./manual.vue?vue&type=script&lang=js&"
import style0 from "./manual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports